import React from "react";

function PauseIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="20.874"
      viewBox="0 0 16 20.874"
    >
      <path
        id="Path_16171"
        data-name="Path 16171"
        d="M23.693,15.445,9.072,25.192A.69.69,0,0,1,8,24.618V5.124A.69.69,0,0,1,9.072,4.55L23.693,14.3a.69.69,0,0,1,0,1.148Z"
        transform="translate(-8 -4.434)"
        fill="#fff"
      />
    </svg>
  );
}

export default PauseIcon;
